
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-floating-action-button",
      function () {
        return require("private-next-pages/material-ui/react-floating-action-button.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-floating-action-button"])
      });
    }
  